module.exports = __webpack_public_path__ + "img/logo.b7682f14.png";